import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/tag-management.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class TagManagementLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  tagAssignment$ = this.storeSelect(selectors.getTagAssignment);
  tagType$ = this.storeSelect(selectors.getTagType);
  tagCode$ = this.storeSelect(selectors.getTagCode);
  tagLabel$ = this.storeSelect(selectors.getTagLabel);
  tagCreate$ = this.storeSelect(selectors.getTagCreate);
  tagCreated$ = this.storeSelect(selectors.getTagCreated);
  tagBrandCode$ = this.storeSelect(selectors.getTagBrandCode);
  tagBrandName$ = this.storeSelect(selectors.getTagBrandName);
  tagEdit$ = this.storeSelect(selectors.getTagEdit);
  tagInactive$ = this.storeSelect(selectors.getTagInactive);
  tagStartDate$ = this.storeSelect(selectors.getTagStartDate);
  tagEndDate$ = this.storeSelect(selectors.getTagEndDate);
  tagUpdate$ = this.storeSelect(selectors.getTagUpdate);
  isActive$ = this.storeSelect(selectors.getIsActive);
  isInactive$ = this.storeSelect(selectors.getIsInactive);
  tagsUpdated$ = this.storeSelect(selectors.getTagsUpdated);

  // OBSERVABLE'S VALUES
  get tagAssignment() {
    return this.storeSnapshot(this.tagAssignment$);
  }

  get tagType() {
    return this.storeSnapshot(this.tagType$);
  }

  get tagCode() {
    return this.storeSnapshot(this.tagCode$);
  }

  get tagLabel() {
    return this.storeSnapshot(this.tagLabel$);
  }

  get tagCreate() {
    return this.storeSnapshot(this.tagCreate$);
  }

  get tagBrandCode() {
    return this.storeSnapshot(this.tagBrandCode$);
  }

  get tagBrandName() {
    return this.storeSnapshot(this.tagBrandName$);
  }

  get tagEdit() {
    return this.storeSnapshot(this.tagEdit$);
  }

  get tagInactive() {
    return this.storeSnapshot(this.tagInactive$);
  }

  get tagStartDate() {
    return this.storeSnapshot(this.tagStartDate$);
  }

  get tagEndDate() {
    return this.storeSnapshot(this.tagEndDate$);
  }

  get tagUpdate() {
    return this.storeSnapshot(this.tagUpdate$);
  }

  get tagCreated() {
    return this.storeSnapshot(this.tagCreated$);
  }

  get tagsUpdated() {
    return this.storeSnapshot(this.tagsUpdated$);
  }
}
